import React, { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import { 
  getActiveNotifications, 
  isNotificationDismissed, 
  dismissNotification
} from '../utils/notifications';

const NotificationBanner = () => {
  const [visibleNotifications, setVisibleNotifications] = useState([]);

  useEffect(() => {
    loadNotifications();
  }, []);

  const loadNotifications = async () => {
    const result = await getActiveNotifications();
    if (result.success && result.data) {
      // Filter out dismissed notifications
      const visible = result.data.filter(
        notification => !isNotificationDismissed(notification.id)
      );
      setVisibleNotifications(visible);
    }
  };

  const handleDismiss = (notificationId) => {
    // Mark as dismissed locally
    dismissNotification(notificationId);
    
    // Remove from visible list
    setVisibleNotifications(prev => 
      prev.filter(n => n.id !== notificationId)
    );
  };

  if (visibleNotifications.length === 0) return null;

  return (
    <div>
      {visibleNotifications.map((notification) => (
        <div
          key={notification.id}
          className="bg-yellow text-[#05339c] border-b-2 border-[#05339c]/10"
        >
          <div className="max-w-full mx-auto px-4 py-2">
            <div className="flex items-center justify-between gap-3">
              {/* Content */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap text-center justify-center">
                  <span className="text-base font-semibold">
                    {notification.message}
                  </span>
                  
                  {notification.link_url && notification.link_text && (
                    <a
                      href={notification.link_url}
                      target="_self"
                      rel="noopener noreferrer"
                      className="text-xs sm:text-sm font-bold underline hover:opacity-70"
                    >
                      {notification.link_text} ←
                    </a>
                  )}
                </div>
              </div>

              {/* Close button */}
              <button
                onClick={() => handleDismiss(notification.id)}
                className="flex-shrink-0 p-1 hover:bg-[#05339c]/10 rounded"
                aria-label="إغلاق الإشعار"
              >
                <FiX className="w-6 h-6" />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationBanner;

